<template>
  <header class="topbar" data-navbarbg="skin6">
    <nav class="navbar top-navbar navbar-expand-md">
      <div class="navbar-header" data-logobg="skin6">
        <!-- This is for the sidebar toggle which is visible on mobile only -->
        <a
          class="nav-toggler waves-effect waves-light d-block d-md-none"
          href="javascript:void(0)"
          ><i class="ti-menu ti-close"></i
        ></a>
        <!-- Logo -->
        <div class="navbar-brand img-fluid" style="margin-left: 20px;">
          <!-- Logo icon -->
          <a href="/">
            <b class="logo-icon img-fluid">
              <img
                src="../assets/img/VIVOT/Logo.png"
                alt="homepage"
                class="dark-logo img-fluid"
              />
            </b>
            <!--End Logo icon -->
          </a>
        </div>
        <!-- ============================================================== -->
        <!-- Toggle which is visible on mobile only  botoncito para abrir el sidebar-->
        <!-- ============================================================== -->
        <a
          class="topbartoggler d-block d-md-none waves-effect waves-light"
          href="javascript:void(0)"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          ><i class="ti-more"></i
        ></a>
      </div>
      <!-- ============================================================== -->
      <!-- End Logo -->
      <!-- ============================================================== -->
      <div id="navbarSupportedContent" class="navbar-collapse collapse">
        <!-- Left nav items -->
        <ul class="navbar-nav float-left mr-auto ml-3 pl-1">
          <!-- <li class="nav-item dropdown">
            <NotificationList />
          </li>-->
        </ul>
        <!-- Right side toggle and nav items -->
        <ul class="navbar-nav float-right">
          <!-- Search Input 
          <li class="nav-item d-none d-md-block">
            <SearchNavbar />
          </li> -->

          <!-- User profile -->
          <li v-if="this.$store.getters.isLoggedIn" class="nav-item dropdown">
            <AccountList />
          </li>

          <li v-else class="nav-item dropdown">
            <div class="btn-list">
              <button
                type="button"
                class="btn btn-outline-primary btn-rounded"
                @click="$router.push('/login')"
              >
                <i class="fas fa-user"></i> LogIn
              </button>
              <button
                type="button"
                class="btn btn-primary btn-rounded"
                @click="$router.push('/register')"
              >
                <i class="far fa-address-card"></i> SignUp
              </button>
            </div>
            <br />
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>
<script>
import AccountList from './AccountList';
// import NotificationList from "./NotificationList";
// import SearchNavbar from "./SearchNavbar";
export default {
  name: 'TheNavbar',
  components: {
    AccountList,
    //NotificationList,
    // SearchNavbar
  },
};
</script>
